import { apiProxyRequest } from "Api/apiProxyRequest";

import type { VoucherList } from "../types";

export const getVouchersRequest = (billingProfileId: string) => {
  return apiProxyRequest<VoucherList>(
    `/billing/profiles/${billingProfileId}/vouchers`
  );
};
